
export enum RequestStatus {
  idle,
  loading,
  failed
}
